<div class="p-3 w-full h-full flex flex-col lg:flex-row gap-3 items-center lg:items-start">
    <div class="w-[400px] lg:h-full lg:pr-3 border-r-0 lg:border-r flex flex-col justify-around">
        <div class="w-full flex flex-col gap-3 items-center">
            <div class="w-[200px] h-[200px] bg-gray-300 border rounded-full shadow-sm">
                <img [src]="settingsService.settings.profilePictureUrl" alt="Profile picture" class="w-full h-full rounded-full object-cover">
            </div>
            <p class="text-lg !m-0">{{settingsService.settings.name}}</p>
            <p class="text-sm text-gray-500">{{settingsService.settings.organization.name}}</p>
        </div>
        <div></div>
    </div>
    <app-account-information-form [_form]="_form" [prefillInformation]="prefillInformation" *ngIf="!isLoading" (_submit)="onSubmit()" (_cancel)="closeDialog()"></app-account-information-form>
    <div class="w-full h-full min-h-[400px] flex justify-center items-center" *ngIf="isLoading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
</div>
